/* np-sport.js — behaviour for sections/new-sport.liquid + snippets/np-sg-page.liquid.
   Reads its per-page key from <script type="application/json" id="sg-config">.
   Cart adds go through the shared window.npCart API (assets/np-chrome.js).

   All 11 calculators live in this one cached asset rather than being emitted
   per page: the file loads once and is reused (browser-cached) across every
   sport/goal page, which ships less total JS than re-inlining a single
   calculator's Liquid-conditional markup on every page load. */
(function () {
  "use strict";
  var configEl = document.getElementById("sg-config");
  var KEY = null;
  if (configEl) {
    try { KEY = (JSON.parse(configEl.textContent) || {}).key || null; } catch (e) { KEY = null; }
  }
  var $ = function (id) { return document.getElementById(id); };
  var all = function (sel) { return document.querySelectorAll(sel); };
  var esc = function (s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;"); };

  /* ---- design calculators (verbatim) ---- */
  var CALCS = {

  hyrox: {
    eyebrow: "Race fuelling", title: "Your race-day", titleEm: "bottle plan.",
    intro: "Set your target time and the arena, and we'll work out the carbs, fluid and sodium to carry, and how to split it.",
    cta: "Shop the race stack", bigLabel: "Carbs for the race", bigUnit: "grams total",
    s1: { label: "Target finish time", min: 55, max: 130, step: 5, def: 85, fmt: function (v) { return Math.floor(v / 60) + "h " + (v % 60) + "m"; } },
    s2: { label: "Bodyweight", min: 50, max: 110, step: 1, def: 78, fmt: function (v) { return v + "kg"; } },
    optLabel: "Arena conditions", options: ["Cool", "Warm", "Hot"],
    run: function (mins, bw, opt) {
      var hrs = mins / 60;
      var rate = 75;
      var carbs = Math.round(rate * hrs);
      var fluid = Math.round((0.6 + 0.25 * opt) * (bw / 78) * hrs * 1000);
      var servings = Math.max(1, Math.round(fluid / 500));
      return {
        big: carbs,
        rows: [
          { k: "Carbs per hour", v: rate + "g" },
          { k: "Fluid across the race", v: "~" + fluid + "ml" },
          { k: "Electrolyte servings", v: servings + " × 400mg sodium" }
        ],
        tiles: [
          { v: rate + "g/h", k: "Fuel rate" },
          { v: servings, k: "Hydration servings" },
          { v: (servings * 400) + "mg", k: "Sodium" }
        ],
        note: opt === 2
          ? "A hot arena is where races unravel. Take the upper end of the fluid range and practise it in training first."
          : "Split the carbs across the first three stations rather than saving them. Hunger shows up before the compromised running does."
      };
    }
  },

  bodybuilding: {
    eyebrow: "Lean gain calculator", title: "Calories and protein", titleEm: "for the block.",
    intro: "A lean gain is a small surplus held for months. Set your numbers and we'll split the target into protein, calories and shakes.",
    cta: "Shop the growth stack", bigLabel: "Daily calories", bigUnit: "kcal a day",
    s1: { label: "Bodyweight", min: 50, max: 130, step: 1, def: 82, fmt: function (v) { return v + "kg"; } },
    s2: { label: "Training days a week", min: 2, max: 7, step: 1, def: 5, fmt: function (v) { return v + " days"; } },
    optLabel: "Phase", options: ["Maintain", "Lean gain", "Bulk"],
    run: function (bw, days, opt) {
      var tdee = Math.round(bw * (28 + days));
      var surplus = [0, 300, 500][opt];
      var kcal = tdee + surplus;
      var protein = Math.round(bw * [1.8, 2.0, 2.2][opt]);
      var shakes = Math.max(0, Math.ceil((protein - 120) / 23));
      return {
        big: kcal,
        rows: [
          { k: "Maintenance estimate", v: tdee + " kcal" },
          { k: "Protein target", v: protein + "g" },
          { k: "Whey servings to get there", v: shakes + " a day" }
        ],
        tiles: [
          { v: "+" + surplus, k: "Surplus" },
          { v: protein + "g", k: "Protein" },
          { v: shakes, k: "Shakes" }
        ],
        note: opt === 2
          ? "A 500 kcal surplus adds weight fast, and some of it will be fat. Most people do better on the lean-gain setting for longer."
          : "Expect 0.25-0.5kg a week on a lean gain. Faster than that and you are buying a cut later."
      };
    }
  },

  crossfit: {
    eyebrow: "Week planner", title: "Fuelling four", titleEm: "hard sessions.",
    intro: "Set your week and we’ll work out hydration servings, where the caffeine should go and what the stack costs per session.",
    cta: "Shop the box stack", bigLabel: "Hydration servings", bigUnit: "a week",
    s1: { label: "Sessions a week", min: 2, max: 10, step: 1, def: 5, fmt: function (v) { return v + (v === 1 ? " session" : " sessions"); } },
    s2: { label: "Session length", min: 30, max: 120, step: 15, def: 60, fmt: function (v) { return v + " min"; } },
    optLabel: "Box temperature", options: ["Cool", "Warm", "Hot"],
    run: function (sessions, mins, opt) {
      var perSession = Math.max(1, Math.round((mins / 60) * (1 + opt * 0.5)));
      var total = perSession * sessions;
      var stim = Math.min(2, Math.max(1, Math.round(sessions / 3)));
      return {
        big: total,
        rows: [
          { k: "Per session", v: perSession + " × 500ml" },
          { k: "High-stimulant sessions", v: stim + " a week" },
          { k: "Creatine", v: "5g daily, all week" }
        ],
        tiles: [
          { v: perSession, k: "Per session" },
          { v: stim, k: "Stim sessions" },
          { v: "5g", k: "Daily creatine" }
        ],
        note: sessions >= 7
          ? "Seven or more sessions a week is a recovery problem before it is a supplement one, protein and sleep first, stimulants last."
          : "Keep the high-stimulant pre-workout for the " + stim + " session" + (stim === 1 ? "" : "s") + " that matter and use the 100mg option elsewhere."
      };
    }
  },

  running: {
    eyebrow: "Long-run fuelling", title: "Carbs and salt", titleEm: "by distance.",
    intro: "Set the distance and your pace and we'll turn it into carbs per hour, bottles and sodium.",
    cta: "Shop the runner's stack", bigLabel: "Carbs for the run", bigUnit: "grams total",
    s1: { label: "Distance", min: 5, max: 42, step: 1, def: 21, fmt: function (v) { return v + "km"; } },
    s2: { label: "Pace", min: 240, max: 420, step: 10, def: 300, fmt: function (v) { return Math.floor(v / 60) + ":" + String(v % 60).padStart(2, "0") + "/km"; } },
    optLabel: "Conditions", options: ["Cool", "Mild", "Hot"],
    run: function (km, pace, opt) {
      var mins = (km * pace) / 60;
      var hrs = mins / 60;
      var rate = hrs <= 1.5 ? 0 : hrs <= 2.5 ? 60 : 90;
      var carbs = Math.round(rate * hrs);
      var fluid = Math.round((0.45 + 0.25 * opt) * hrs * 1000);
      var servings = Math.max(1, Math.round(fluid / 500));
      return {
        big: carbs,
        rows: [
          { k: "Time on feet", v: Math.floor(hrs) + "h " + Math.round(mins % 60) + "m" },
          { k: "Carbs per hour", v: rate + "g" },
          { k: "Electrolyte servings", v: servings + " × 400mg sodium" }
        ],
        tiles: [
          { v: rate + "g/h", k: "Fuel rate" },
          { v: "~" + fluid + "ml", k: "Fluid" },
          { v: (servings * 400) + "mg", k: "Sodium" }
        ],
        note: rate === 0
          ? "Under about ninety minutes you can run on stored glycogen. Take electrolytes for the sweat and save the carbs for long days."
          : "Start fuelling inside the first half hour. Carrying " + carbs + "g means roughly " + Math.ceil(carbs / 30) + " servings of carbs across the run."
      };
    }
  },

  padel: {
    eyebrow: "Match-day planner", title: "Bottles and", titleEm: "caffeine timing.",
    intro: "Set your match and we'll work out what to carry on court and whether the caffeine will cost you sleep.",
    cta: "Shop the match stack", bigLabel: "On-court bottles", bigUnit: "× 500ml",
    s1: { label: "Match length", min: 45, max: 150, step: 15, def: 90, fmt: function (v) { return v + " min"; } },
    s2: { label: "First serve", min: 8, max: 21, step: 1, def: 19, fmt: function (v) { return (v > 12 ? (v - 12) + "pm" : v + "am"); } },
    optLabel: "Court", options: ["Outdoor cool", "Indoor", "Hot day"],
    run: function (mins, hour, opt) {
      var hrs = mins / 60;
      var bottles = Math.max(1, Math.round(hrs * (0.8 + opt * 0.35)));
      var late = hour >= 17;
      return {
        big: bottles,
        rows: [
          { k: "Sodium across the match", v: (bottles * 400) + "mg" },
          { k: "Caffeine", v: late ? "Skip it, too late" : "100mg, 20 min before" },
          { k: "Protein after", v: "22–23g within 2 hours" }
        ],
        tiles: [
          { v: bottles, k: "Bottles" },
          { v: (bottles * 400) + "mg", k: "Sodium" },
          { v: late ? "PM" : "OK", k: "Caffeine window" }
        ],
        note: late
          ? "A 5pm-or-later start puts caffeine inside the eight hours before bed. Use the caffeine-free Hydration Electrolytes and keep the sleep."
          : "Daytime start, so the caffeinated option is fine: 100mg with 200mg of L-theanine, twenty minutes before you walk on."
      };
    }
  },

  strength: {
    eyebrow: "Block planner", title: "Protein and creatine", titleEm: "for a heavy block.",
    intro: "Set your bodyweight and the block length and we'll work out the protein target, creatine timeline and what a tub covers.",
    cta: "Shop the strength stack", bigLabel: "Daily protein", bigUnit: "grams a day",
    s1: { label: "Bodyweight", min: 55, max: 140, step: 1, def: 90, fmt: function (v) { return v + "kg"; } },
    s2: { label: "Block length", min: 4, max: 16, step: 1, def: 12, fmt: function (v) { return v + " weeks"; } },
    optLabel: "Sessions a week", options: ["3", "4", "5"],
    run: function (bw, weeks, opt) {
      var sessions = [3, 4, 5][opt];
      var protein = Math.round(bw * 1.8);
      var shakes = Math.max(0, Math.ceil((protein - 130) / 23));
      var creatineTubs = Math.ceil((weeks * 7) / 60);
      return {
        big: protein,
        rows: [
          { k: "Whey servings a day", v: shakes + " to close the gap" },
          { k: "Creatine for the block", v: creatineTubs + " tub" + (creatineTubs === 1 ? "" : "s") },
          { k: "Stimulant sessions", v: Math.min(2, Math.round(sessions / 2)) + " a week" }
        ],
        tiles: [
          { v: "1.8g/kg", k: "Protein ratio" },
          { v: sessions, k: "Sessions a week" },
          { v: creatineTubs, k: "Creatine tubs" }
        ],
        note: "Creatine is 5g a day for all " + weeks + " weeks, saturation takes three to four, so starting on week one matters more than the dose does."
      };
    }
  },

  "build-muscle": {
    eyebrow: "Protein calculator", title: "How much protein", titleEm: "you actually need.",
    intro: "Total daily protein is the variable that decides whether a training block shows up. Set your bodyweight and goal and we'll break the target into meals.",
    cta: "Shop protein", bigLabel: "Daily protein target", bigUnit: "grams a day",
    s1: { label: "Bodyweight", min: 45, max: 130, step: 1, def: 80, fmt: function (v) { return v + "kg"; } },
    s2: { label: "Meals a day", min: 3, max: 6, step: 1, def: 4, fmt: function (v) { return v + " meals"; } },
    optLabel: "Goal", options: ["Maintain", "Lean gain", "Bulk"],
    run: function (bw, meals, opt) {
      var perKg = [1.6, 2.0, 2.2][opt];
      var total = Math.round(bw * perKg);
      var perMeal = Math.round(total / meals);
      var shakes = Math.max(0, Math.ceil((total - meals * 30) / 23));
      return {
        big: total, rows: [
          { k: "Per meal", v: perMeal + "g" },
          { k: "Leucine per meal", v: (perMeal * 0.105).toFixed(1) + "g" },
          { k: "Whey servings to close the gap", v: shakes + " a day" }
        ],
        tiles: [
          { v: perKg + "g/kg", k: "Target ratio" },
          { v: perMeal + "g", k: "Per meal" },
          { v: shakes, k: "Shakes" }
        ],
        note: perMeal < 25
          ? "Under 25g a meal blunts the synthesis response, fewer, larger feeds work better than six small ones."
          : "Each feed clears the leucine threshold. One whey serving is 22–23g, which is what makes the last 40-50g realistic on a busy day."
      };
    }
  },

  "recovery-sleep": {
    eyebrow: "Sleep debt", title: "What you're", titleEm: "carrying.",
    intro: "Sleep debt builds up: thirty lost minutes a night adds up across a week. Set the hours you slept last night and how many poor nights you had this week.",
    cta: "Shop recovery", bigLabel: "Weekly sleep debt", bigUnit: "hours owed",
    s1: { label: "Hours slept last night", min: 4, max: 10, step: 0.5, def: 6.5, fmt: function (v) { return v + "h"; } },
    s2: { label: "Poor nights this week", min: 0, max: 7, step: 1, def: 3, fmt: function (v) { return v + (v === 1 ? " night" : " nights"); } },
    optLabel: "Your sleep target", options: ["7 hours", "8 hours", "9 hours"],
    run: function (slept, bad, opt) {
      var target = [7, 8, 9][opt];
      var nightly = Math.max(0, target - slept);
      var debt = +(nightly * Math.max(bad, 1)).toFixed(1);
      var nights = Math.ceil(debt / 1.5);
      var loss = Math.min(35, Math.round(debt * 3));
      return {
        big: debt, rows: [
          { k: "Deficit last night", v: nightly.toFixed(1) + "h" },
          { k: "Nights to clear it", v: nights + " at +1.5h" },
          { k: "Estimated performance cost", v: loss + "%" }
        ],
        tiles: [
          { v: target + "h", k: "Your target" },
          { v: nightly.toFixed(1) + "h", k: "Short by" },
          { v: nights, k: "Nights to clear" }
        ],
        note: debt < 2
          ? "Close to even. Hold the routine rather than chasing extra hours at the weekend."
          : "Clear it with earlier nights rather than lie-ins, and take magnesium bisglycinate 60 minutes before bed while you do."
      };
    }
  },

  "endurance": {
    eyebrow: "Session fuelling", title: "Carbs, fluid", titleEm: "and salt.",
    intro: "Past ninety minutes, fuel and fluid decide the last third of the session. Set the duration and conditions and we'll work out what to carry.",
    cta: "Shop endurance", bigLabel: "Carbs for the session", bigUnit: "grams total",
    s1: { label: "Session length", min: 30, max: 240, step: 15, def: 120, fmt: function (v) { return (v >= 60 ? (v / 60) + "h" : v + "min"); } },
    s2: { label: "Bodyweight", min: 45, max: 110, step: 1, def: 75, fmt: function (v) { return v + "kg"; } },
    optLabel: "Conditions", options: ["Cool", "Warm", "Hot"],
    run: function (mins, bw, opt) {
      var hrs = mins / 60;
      var carbPerHr = hrs <= 1 ? 0 : hrs <= 2 ? 60 : 90;
      var carbs = Math.round(carbPerHr * hrs);
      var sweatPerHr = (0.5 + 0.25 * opt) * (bw / 75);
      var fluid = Math.round(sweatPerHr * hrs * 1000);
      var servings = Math.max(1, Math.round(fluid / 500));
      return {
        big: carbs, rows: [
          { k: "Carbs per hour", v: carbPerHr + "g" },
          { k: "Fluid to replace", v: "~" + fluid + "ml" },
          { k: "Electrolyte servings", v: servings + " × 400mg sodium" }
        ],
        tiles: [
          { v: carbPerHr + "g/h", k: "Fuel rate" },
          { v: servings, k: "Hydration servings" },
          { v: (servings * 400) + "mg", k: "Sodium" }
        ],
        note: carbPerHr === 0
          ? "Under an hour you can run on stored glycogen. Take electrolytes for the sweat, and leave the carbs for longer days."
          : "Start fuelling in the first half hour rather than waiting to feel empty, and alternate carbs with electrolytes from there."
      };
    }
  },

  "performance": {
    eyebrow: "Stimulant planner", title: "Caffeine that", titleEm: "doesn't cost you.",
    intro: "Caffeine works until it costs you sleep. Set your training time and weekly load and we'll set the dose and the cut-off.",
    cta: "Shop performance", bigLabel: "Caffeine for training", bigUnit: "mg per session",
    s1: { label: "Training start", min: 5, max: 21, step: 1, def: 17, fmt: function (v) { return (v > 12 ? (v - 12) + "pm" : v + "am"); } },
    s2: { label: "Sessions a week", min: 2, max: 7, step: 1, def: 4, fmt: function (v) { return v + (v === 1 ? " session" : " sessions"); } },
    optLabel: "Caffeine tolerance", options: ["Low", "Normal", "High"],
    run: function (hour, sessions, opt) {
      var dose = [100, 200, 300][opt];
      var cutoff = 22 - 8;
      var late = hour >= cutoff;
      var perWeek = dose * sessions;
      return {
        big: late ? Math.min(dose, 100) : dose, rows: [
          { k: "Weekly caffeine from training", v: perWeek + "mg" },
          { k: "Hard cut-off for a 10pm bed", v: "2pm" },
          { k: "Creatine, regardless of timing", v: "5g daily" }
        ],
        tiles: [
          { v: sessions, k: "Sessions a week" },
          { v: (late ? "Late" : "Fine"), k: "Session timing" },
          { v: "5g", k: "Daily creatine" }
        ],
        note: late
          ? "That session lands inside the eight hours before bed. Keep caffeine at 100mg or skip it, and let the creatine do the work instead."
          : "Comfortably clear of bedtime. Use the high-stimulant pre-workout for one or two sessions a week and the 100mg option for the rest."
      };
    }
  },

  "health-wellness": {
    eyebrow: "Daily foundations", title: "Your daily", titleEm: "minimums.",
    intro: "Your minimums for protein, sleep and the micronutrients that training uses up, worked out for you.",
    cta: "Shop the foundations", bigLabel: "Daily protein floor", bigUnit: "grams a day",
    s1: { label: "Bodyweight", min: 45, max: 130, step: 1, def: 75, fmt: function (v) { return v + "kg"; } },
    s2: { label: "Training days a week", min: 0, max: 7, step: 1, def: 3, fmt: function (v) { return v + (v === 1 ? " day" : " days"); } },
    optLabel: "How you eat", options: ["Mostly home cooked", "Mixed", "On the go"],
    run: function (bw, days, opt) {
      var floor = Math.round(bw * (days >= 4 ? 1.8 : 1.6));
      var gap = [0, 1, 2][opt];
      var sweatWeeks = days >= 4 ? "Every day" : "Most days";
      return {
        big: floor, rows: [
          { k: "Protein servings to top up", v: gap + " a day" },
          { k: "Zinc & magnesium", v: sweatWeeks },
          { k: "Sleep target", v: days >= 5 ? "8-9 hours" : "7–8 hours" }
        ],
        tiles: [
          { v: (days >= 4 ? "1.8" : "1.6") + "g/kg", k: "Protein ratio" },
          { v: days, k: "Training days" },
          { v: gap, k: "Shakes to fill in" }
        ],
        note: gap === 0
          ? "If most meals are home cooked you can hit this from food alone, keep the micronutrients and sleep support and skip the powder."
          : "Eating on the go is where protein slips. One or two servings a day closes the gap without changing anything else."
      };
    }
  }

  };

  var calc = KEY ? CALCS[KEY] : null;
  if (calc && $("sg-s1")) {
    var st = { c1: calc.s1.def, c2: calc.s2.def, c3: 1 };
    $("sg-calc-eyebrow").textContent = calc.eyebrow;
    if ($("sg-hero-calc")) $("sg-hero-calc").textContent = calc.eyebrow;
    $("sg-calc-title").innerHTML = esc(calc.title) + ' <em style="font-style:italic">' + esc(calc.titleEm) + "</em>";
    $("sg-calc-intro").textContent = calc.intro;
    $("sg-calc-cta").textContent = calc.cta;
    $("sg-biglabel").textContent = calc.bigLabel;
    $("sg-bigunit").textContent = calc.bigUnit;
    $("sg-s1l").textContent = calc.s1.label; $("sg-s2l").textContent = calc.s2.label; $("sg-optl").textContent = calc.optLabel;
    var s1 = $("sg-s1"), s2 = $("sg-s2");
    s1.min = calc.s1.min; s1.max = calc.s1.max; s1.step = calc.s1.step; s1.value = st.c1;
    s2.min = calc.s2.min; s2.max = calc.s2.max; s2.step = calc.s2.step; s2.value = st.c2;
    var opts = $("sg-opts");
    calc.options.forEach(function (n, i) {
      var b = document.createElement("button"); b.type = "button"; b.setAttribute("data-sgopt", i); b.setAttribute("aria-pressed", i === 1 ? "true" : "false"); b.textContent = n;
      b.style.cssText = "border:1px solid rgba(255,255,255,.28);background:transparent;color:#fff;border-radius:100px;padding:13px 22px;font:700 13px/1 Inter,system-ui,sans-serif;cursor:pointer";
      b.addEventListener("click", function () { st.c3 = i; run(); });
      opts.appendChild(b);
    });
    function run() {
      var res = calc.run(st.c1, st.c2, st.c3);
      $("sg-s1v").textContent = calc.s1.fmt(st.c1);
      $("sg-s2v").textContent = calc.s2.fmt(st.c2);
      $("sg-big").textContent = res.big;
      $("sg-note").textContent = res.note;
      $("sg-rows").innerHTML = res.rows.map(function (r) {
        return '<div style="background:#0B0B0B;padding:16px 18px;display:flex;align-items:baseline;justify-content:space-between;gap:14px"><span style="font:400 13.5px/1.35 Inter,system-ui,sans-serif;color:rgba(255,255,255,.6)">' + esc(r.k) + '</span><span style="font:700 16px/1 Inter,system-ui,sans-serif;color:#FFDD0E;text-align:right">' + esc(r.v) + "</span></div>";
      }).join("");
      $("sg-tiles").innerHTML = res.tiles.map(function (t) {
        return '<div><div style="font:800 24px/1 \'Xenon Nue\',\'Helvetica Neue\',Helvetica,Arial,sans-serif;letter-spacing:-0.004em;color:#FFDD0E">' + esc(t.v) + '</div><div style="font:500 9.5px/1.4 \'Kode Mono\',ui-monospace,monospace;letter-spacing:.12em;text-transform:uppercase;color:rgba(255,255,255,.5);margin-top:8px">' + esc(t.k) + "</div></div>";
      }).join("");
      all("[data-sgopt]").forEach(function (b, i) {
        var on = i === st.c3;
        b.setAttribute("aria-pressed", on ? "true" : "false");
        b.style.background = on ? "#FFDD0E" : "transparent"; b.style.color = on ? "#0B0B0B" : "#fff"; b.style.borderColor = on ? "#FFDD0E" : "rgba(255,255,255,.28)";
      });
    }
    s1.addEventListener("input", function () { st.c1 = Number(s1.value); run(); });
    s2.addEventListener("input", function () { st.c2 = Number(s2.value); run(); });
    run();
  }

  /* ---- compounds spotlight ---- */
  all("[data-sgc]").forEach(function (b) {
    b.addEventListener("click", function () {
      all("[data-sgc]").forEach(function (o) {
        var on = o === b;
        o.setAttribute("aria-pressed", on ? "true" : "false");
        o.style.background = on ? "#FFDD0E" : "rgba(255,255,255,.05)";
        o.querySelector("[data-sgcn]").style.color = on ? "#0B0B0B" : "#fff";
        o.querySelector("[data-sgcd]").style.color = on ? "rgba(11,11,11,.6)" : "rgba(255,255,255,.45)";
      });
      $("sg-spot-name").textContent = b.dataset.name; $("sg-spot-body").textContent = b.dataset.body;
      $("sg-spot-a").textContent = b.dataset.a; $("sg-spot-ak").textContent = b.dataset.ak;
      $("sg-spot-b").textContent = b.dataset.b; $("sg-spot-bk").textContent = b.dataset.bk;
    });
  });

  /* ---- FAQ accordions (shared .npfaq-* classes, see np-base.css) ---- */
  var faqButtons = all("[data-acc]");
  faqButtons.forEach(function (btn) {
    btn.setAttribute("aria-expanded", "false");
    btn.addEventListener("click", function () {
      var open = btn.getAttribute("aria-expanded") === "true";
      faqButtons.forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
        var bd = b.parentElement.querySelector(".npfaq-body");
        if (bd) bd.classList.remove("is-open");
      });
      if (!open) {
        btn.setAttribute("aria-expanded", "true");
        var body = btn.parentElement.querySelector(".npfaq-body");
        if (body) body.classList.add("is-open");
      }
    });
  });

  /* ---- single-variant Add: shared cart API ---- */
  all("[data-sgadd]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var items = [{ id: parseInt(btn.dataset.sgadd, 10), quantity: 1 }];
      /* npCart announces failures in its toast; nothing else to do here */
      if (window.npCart) window.npCart.add(items, { button: btn }).catch(function () {});
    });
  });
})();
